import type { MediaSessionConfig } from '@yandex-360/telemost-sdk/device-manager';
import type {
    SessionConfigFlags,
    SoundProcessorOptions,
    VideoProcessorOptions,
} from '@yandex-video-platform/goloom-sdk';

import { DEFAULT_FLAGS } from '../../../goloom-sdk/constants';
import { mapSoundProcessorOptionsFromGoloom, mapVideoProcessorOptionsFromGoloom } from './goloom-type-mappers';

type ReduxSessionConfig = {
    soundProcessing?: SoundProcessorOptions;
    videoProcessing?: VideoProcessorOptions;
    flags?: SessionConfigFlags;
};

export function buildGoloomInitConfig(config: ReduxSessionConfig): MediaSessionConfig {
    return {
        soundProcessing: config.soundProcessing
            ? mapSoundProcessorOptionsFromGoloom(config.soundProcessing)
            : undefined,
        videoProcessing: config.videoProcessing
            ? mapVideoProcessorOptionsFromGoloom(config.videoProcessing)
            : undefined,
        flags: {
            ...DEFAULT_FLAGS,
            keepDefaultDevices: true,
            ...config.flags,
        },
    };
}
